(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyOperationService', CompanyOperationService)

    /** @ngInject */
    function CompanyOperationService(HttpService) {
        const CompanyOperationService = {
            getHours,
            post,
            put
        }

        return CompanyOperationService;

        function getHours() {
            return HttpService.get('/companies/operations/hours');
        }

        function post(companyOperationData) {
            return HttpService.post('/companies/operations', companyOperationData);
        }

        function put(companyOperationData) {
            return HttpService.put('/companies/operations', companyOperationData);
        }
    }
}());